import { createGlobalStyle } from 'styled-components';
import ColorResource from '../services/resources/ColorResource';
import { ButtonTypes } from '../services/exports/Interfaces';
import { ITheme } from '../providers/ThemeProvider';

const GlobalStyle = createGlobalStyle<{ theme: ITheme }>`
    :root {
      --primary-color-rgb: ${({ theme }) => ColorResource.getRgbValue(theme.color.brand.primary)};
      --background-primary-color-rgb: ${({ theme }) => ColorResource.getRgbValue(theme.color.brand.background.primary)};
      --background-secondary-color-rgb: ${({ theme }) => ColorResource.getRgbValue(theme.color.brand.background.secondary)};
      --background-hover-color-rgb: ${({ theme }) => ColorResource.getRgbValue(theme.color.brand.background.hover)};
      --border-color-rgb: ${({ theme }) => ColorResource.getRgbValue(theme.color.brand.border)};
      --card-color-rgb: ${({ theme }) => ColorResource.getRgbValue(theme.color.brand.card)};
      --text-primary-color-rgb: ${({ theme }) => ColorResource.getRgbValue(theme.color.brand.text.primary)};
      --text-secondary-color-rgb: ${({ theme }) => ColorResource.getRgbValue(theme.color.brand.text.secondary)};
      --icon-color-rgb: ${({ theme }) => ColorResource.getRgbValue(theme.color.brand.icon.color)};
      --icon-background-rgb: ${({ theme }) => ColorResource.getRgbValue(theme.color.brand.icon.background)};
      --disabled-background-rgb: ${({ theme }) => ColorResource.getRgbValue(theme.color.brand.disabled.background)};
      --border-radius-none: ${({ theme }) => theme.border.radius.none};
      --border-radius-sm: ${({ theme }) => theme.border.radius.sm};
      --border-radius-DEFAULT: ${({ theme }) => theme.border.radius.DEFAULT};
      --border-radius-md: ${({ theme }) => theme.border.radius.md};
      --border-radius-lg: ${({ theme }) => theme.border.radius.lg};
      --border-radius-xl: ${({ theme }) => theme.border.radius.xl};
      --border-radius-2xl: ${({ theme }) => theme.border.radius['2xl']};
      --border-radius-3xl: ${({ theme }) => theme.border.radius['3xl']};
      --border-radius-4xl: ${({ theme }) => theme.border.radius['4xl']};
      --border-radius-5xl: ${({ theme }) => theme.border.radius['5xl']};
      --border-radius-6xl: ${({ theme }) => theme.border.radius['6xl']};
      --border-radius-full: ${({ theme }) => theme.border.radius.full};

      --border-width-none: ${({ theme }) => theme.border.width.none};
      --border-width-small: ${({ theme }) => theme.border.width.sm};
      --border-width-DEFAULT: ${({ theme }) => theme.border.width.DEFAULT};
      --border-width-medium: ${({ theme }) => theme.border.width.md};
      --border-width-large: ${({ theme }) => theme.border.width.lg};
      
    ${({ theme }) =>
      Object.keys(ButtonTypes)
        .map(
          (type) => `
          --button-${type}-background-rgb: ${ColorResource.getRgbValue(theme.buttons[type].background)};
          --button-${type}-text-rgb: ${ColorResource.getRgbValue(theme.buttons[type].text)};
          --button-${type}-border-rgb: ${ColorResource.getRgbValue(theme.buttons[type].border)};
        `,
        )
        .join('\n')}

    }
    body, html {
      overflow-x: clip;
      overflow: visible;
    }
    body {
      margin: 0;
      padding: 0;
      color: ${({ theme }) => theme.color.brand.text.primary};
      background-color: ${({ theme }) => theme.color.brand.background.primary};
      font-family: Inter;
      -webkit-tap-highlight-color: transparent;
      -webkit-touch-callout: none;
      outline: none !important;
      position: relative;
    }
    header {
      position: -webkit-sticky;
      position: sticky;
      top: 0;
      z-index: 50;
    }
    select {
      outline: none !important;
    }
    button, label, a {
      user-select: none;
      position:relative;
    }
    .touchable-highlight {
      -webkit-tap-highlight-color: white;
    }

    .pac-container {
      background-color: ${({ theme }) => theme.color.brand.card};
      color: ${({ theme }) => theme.color.brand.text.primary};
      border: 1px solid ${({ theme }) => theme.color.brand.border};
      z-index: 10000 !important;
    }

    .pac-item {
      background-color: transparent;
      color: ${({ theme }) => theme.color.brand.text.secondary};
    }

    .pac-item:hover {
      background-color: ${({ theme }) => theme.color.brand.background.secondary};
    }

    .pac-item-query {
      color: ${({ theme }) => theme.color.brand.text.primary};
    }

    input:-webkit-autofill,
    textarea:-webkit-autofill,
    select:-webkit-autofill {
    -webkit-box-shadow: ${({ theme }) => (theme.isDarkMode ? '0 0 0 1000px #1e1e1e inset' : 'auto')}; 
    -webkit-text-fill-color: ${({ theme }) => theme.color.brand.text.primary};               
    caret-color: ${({ theme }) => theme.color.brand.text.primary};                          
    transition: background-color 5000s ease-in-out 0s; 
    }

    input:-webkit-autofill:focus,
    textarea:-webkit-autofill:focus,
    select:-webkit-autofill:focus {
      -webkit-box-shadow: ${({ theme }) => (theme.isDarkMode ? '0 0 0 1000px #2a2a2a inset' : 'auto')};
      -webkit-text-fill-color: ${({ theme }) => theme.color.brand.text.primary};
    }
`;

export default GlobalStyle;
